export default __webpack_public_path__ + "static/media/web-dev.e943b1aa.png";